import { __assign } from "tslib";
import React, { Suspense, lazy, useState, useEffect } from 'react';
import ErrorBoundary from '../../ErrorBoundary';
import LoadingIndicator from '../../LoadingIndicator';
import retry from '../../utils/webpack/chunkRetry';
var MediaSelector = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "mediaPopup", webpackPrefetch: true */
        './MediaManager.connected');
    });
});
export var LoadableMediaManager = function (props) {
    var _a = useState(false), mounted = _a[0], setMounted = _a[1];
    useEffect(function () {
        setMounted(true);
    }, []);
    var waitForMount = typeof window === 'undefined' && !mounted;
    if (waitForMount) {
        return null;
    }
    return (React.createElement(ErrorBoundary, { debugComponent: "LoadableMediaManager" },
        React.createElement(Suspense, { fallback: React.createElement(LoadingIndicator, { view: 'spinner', coverMode: true }) },
            React.createElement(MediaSelector, __assign({}, props)))));
};
LoadableMediaManager.displayName = 'LoadableMediaManager';
export default LoadableMediaManager;
//# sourceMappingURL=LoadableMediaManager.js.map